import { toSignInAPI } from '../Api/SignInAPI';
import { FormPayload } from '../types';
import {
  updateAuthTokenDurationStorage,
  updateAuthTokenStorage,
} from '../../../../Utils/Auth';

export interface Input {
  values: FormPayload;
  preAction: () => void;
  doAction: () => void;
  errorAction: (message: string) => void;
}
export const submitHandle = async ({
  values,
  preAction,
  doAction,
  errorAction,
}: Input) => {
  let res = null;
  preAction();

  try {
    res = await toSignInAPI(values);

    updateAuthTokenStorage(res.token);
    updateAuthTokenDurationStorage(Number(res.tokenDuration));
    doAction();
    // @ts-ignore
  } catch (e: never) {
    if (!e) return;

    if ((e && e?.status === 401) || e?.status === 422) {
      const message = await e.text();

      errorAction(message);
    }
  } finally {
    await res;
  }
};
